import {
  AppConnectionErrorScreen,
  AppLoadingScreen,
} from "./features/app/AppStatusScreens";
import { TeamScreenRouter } from "./features/app/TeamScreenRouter";
import type { TeamMember, TeamUser } from "./hooks/teamTypes";
import { useTeamAppPresenter } from "./hooks/useTeamAppPresenter";
import { useTeamController } from "./hooks/useTeamController";

interface AppProps {
  teamId: string;
  user: TeamUser;
  member: TeamMember;
  linkGoogle?: (() => Promise<TeamUser>) | null;
}

export default function App({ teamId, user, member, linkGoogle }: AppProps) {
  const controller = useTeamController({ teamId, user });
  const model = useTeamAppPresenter({
    teamId,
    user,
    member,
    ...(linkGoogle !== undefined ? { linkGoogle } : {}),
    controller,
  });

  if (controller.data.loading) {
    return <AppLoadingScreen />;
  }
  if (controller.data.dataError) {
    return (
      <AppConnectionErrorScreen onRetry={() => window.location.reload()} />
    );
  }

  return <TeamScreenRouter model={model} />;
}
